import Vue from "vue";
import VueRouter from "vue-router";
import defaultLayout from "../layout/default.vue"; //内页用，不带导航的
import rootLayout from "../layout/root.vue"; //带有底部导航的布局
import http from "../core/http";
import wxCodeJS from "@/core/wxCode";
import Utils from "../core/index";
import store from "@/store";
import changeStorage from '../core/changeStorage'

// import wx from "weixin-js-sdk";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  {
    // 带有底部导航的页面
    path: "/",
    component: rootLayout,
    children: [
      { path: "/", meta: {}, component: () => import("../views/productnt.vue") },
      // { path: '/product', meta: {}, component: () => import('../views/index.vue') },
      { path: "/my", meta: {}, component: () => import("../views/my.vue") },
    ],
  },
  {
    // 没有底部导航的页面
    path: "/",
    component: defaultLayout,
    children: [
      {
        path: "/externallyproduct",
        meta: {},
        component: () => import("../views/externallyproduct.vue"),
      },
      { path: "/comp", meta: {}, component: () => import("../views/comp.vue") },
      { path: "/http", meta: {}, component: () => import("../views/http.vue") },
      { path: "/vuex", meta: {}, component: () => import("../views/vuex.vue") },
      {
        path: "/welogin",
        meta: {},
        component: () => import("../views/welogin.vue"),
      },
      { path: "/info", meta: {}, component: () => import("../views/info.vue") },
      {
        path: "/codelogin",
        meta: {},
        component: () => import("../views/codelogin.vue"),
      },
      {
        path: "/applyuser",
        meta: {},
        component: () => import("../views/applyuser.vue"),
      }
      , //验证码登录
      {
        path: "/invitelogin",
        meta: {},
        component: () => import("../views/invitelogin.vue"),
      }, //邀请码登录
      {
        path: "/merchantsdetail",
        meta: {},
        component: () => import("../views/merchantsdetail.vue"),
      }, //商户详情
      {
        path: "/promote",
        meta: {},
        component: () => import("../views/promote.vue"),
      }, // 去推广（注册店员也是此页面）（大的轮播图
      {
        path: "/promotesingle",
        meta: {},
        component: () => import("../views/promotesingle.vue"),
      }, // 单个产品推广海报轮播图
      {
        path: "/identifycard",
        meta: {},
        component: () => import("../views/identifycard.vue"),
      }, // 扫码识别办卡产品页  inviteCode
      {
        path: "/identifycardapp",
        meta: {},
        component: () => import("../views/identifycardapp.vue"),
      }, // 扫码识别办卡产品页  inviteCode
      {
        path: "/cardprepage",
        meta: {},
        component: () => import("../views/cardprepage.vue"),
      }, // 申请办卡前置页
      {
        path: "/recruimentagency",
        meta: {},
        component: () => import("../views/recruimentagency.vue"),
      }, // 注册店员 inviteCode
      {
        path: "/registerfeedback",
        meta: {},
        component: () => import("../views/registerfeedback.vue"),
      }, // 注册结果页
      {
        path: "/cardlist",
        meta: {},
        component: () => import("../views/cardlist.vue"),
      }, // 银行卡列表
      {
        path: "/bankinsert",
        meta: {},
        component: () => import("../views/bankinsert.vue"),
      }, // 绑定银行卡
      {
        path: "/applywithdrawal",
        meta: {},
        component: () => import("../views/applywithdrawal.vue"),
      }, // 申请提现
      {
        path: "/incomedetails",
        meta: {},
        component: () => import("../views/incomedetails.vue"),
      }, // 收入明细
      {
        path: "/monthdetails",
        meta: {},
        component: () => import("../views/monthdetails.vue"),
      }, // 本月已转
      {
        path: "/cardorder",
        meta: {},
        component: () => import("../views/cardorder.vue"),
      }, // 申卡订单
      {
        path: "/teamlist",
        meta: {},
        component: () => import("../views/teamlist.vue"),
      }, // 我的团队
      {
        path: "/teamdetail/:shopUserId",
        meta: {},
        component: () => import("../views/teamdetail.vue"),
      }, // 我的团队-详情
      {
        path: "/rewordrules",
        meta: {},
        component: () => import("../views/rewordrules.vue"),
      }, // 奖励规则
      {
        path: "/loanorder",
        meta: {},
        component: () => import("../views/loanorder.vue"),
      }, // 贷款订单
      {
        path: "/pullneworder",
        meta: {},
        component: () => import("../views/pullneworder.vue"),
      }, // 拉新订单
      {
        path: "/productdetailpre",
        meta: {},
        component: () => import("../views/productdetailpre.vue"),
      }, // 办卡产品前置页的产品介绍图（点击提交 进入三要素提交页面）
      {
        path: "/productdetail",
        meta: {},
        component: () => import("../views/productdetail.vue"),
      }, // 产品详情 （产品卡点击页面 ）
      {
        path: "/newcomerpushcard",
        meta: {},
        component: () => import("../views/newcomerpushcard.vue"),
      }, // 新人推卡
      {
        path: "/oldpushnew",
        meta: {},
        component: () => import("../views/oldpushnew.vue"),
      }, // 老带新
      {
        path: "/rankinglist",
        meta: {},
        component: () => import("../views/rankinglist.vue"),
      }, // 龙虎办单
      {
        path: "/smslink",
        meta: {},
        component: () => import("../views/smslink.vue"),
      }, // 短信链接
      {
        path: "/progressquery",
        meta: {},
        component: () => import("../views/progressquery.vue"),
      }, // 银行进度查询
      { path: "/jump", meta: {}, component: () => import("../views/jump.vue") }, // 跳转
      {
        path: "/errPage",
        meta: {},
        component: () => import("../views/errpage.vue"),
      },
      {
        path: "/configurationPricePage",
        meta: {},
        component: () => import("../views/configurationPricePage.vue"),
      }, // 配置价格页
      {
        path: "/groupChangePricePage",
        meta: {},
        component: () => import("../views/groupChangePricePage.vue"),
      }, // 团队调价页
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  // console.log('beforeEach',to,from,'23tfag',process.env.BASE_URL)
  let isWeixin;
  let ua = navigator.userAgent.toLowerCase();
  isWeixin = ua.indexOf("micromessenger") != -1;
  // console.log('isWeixin',this.isWeixin)    // true 为 微信内置浏览器环境
  let url = window.location.href.split("#")[0];
  store.commit("pagew/setInitLink", url);

  // let data = {
  //   openId: "oN3is6O_RQo7fAvw5mq0EL9A4Ftc",
  //   shopUserId: 21,
  //   token: "8C0F4AE328204FB2B83E40DF1A9A5C91",
  //   userAvatarUrl:
  //     "https://mhproject.oss-cn-shanghai.aliyuncs.com/guangdaminiwx/sh/default_wx_avaul.png",
  //   userMobile: "133****3496",
  //   userName: "2f",
  //   inviteCode: "1234",
  //   userType: 2,
  // };
  // let location = {
  //   latitude: 31.22114,
  //   longitude: 121.54409,
  // };

  // localStorage.openid = "oN3is6O_RQo7fAvw5mq0EL9A4Ftc";
  // localStorage.authentication = "8C0F4AE328204FB2B83E40DF1A9A5C91";
  // localStorage.isLogin = 1;
  // localStorage.userInfo = JSON.stringify(data);
  // changeStorage.set("location",JSON.stringify(location),60000*1)
  // localStorage.location = JSON.stringify(location);

  // HL 信息
  // let data = {
  //   openId: "oDKKs1RLqf9aTR1QxIWXkf1luCFg",
  //   shopUserId: 1,
  //   token: "C291C25ED783473086AD447A498A13CA",
  //   userAvatarUrl: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKUXfDPNGBk4vPj31N1c3odGvtwWCWnkebOOkcZeCQXicHzGQAhxldagAtxic4uicib6A4u1VIRBNs5Dw/132",
  //   userMobile: '185****0215',
  //   userName: "HL",
  //   inviteCode: '1234',
  //   userType: 2
  // }
  // let location = {
  //   latitude: 31.22114,
  //   longitude: 121.54409
  // }

  // localStorage.openid = 'oDKKs1RLqf9aTR1QxIWXkf1luCFg';
  // localStorage.authentication = 'A505C24AF68644CC8DBD5F6FC892B2AF';
  // localStorage.isLogin = 1
  // localStorage.userInfo = JSON.stringify(data);
  // changeStorage.set("location",JSON.stringify(location),6*  24 * 60 * 60 *1000)
  // localStorage.location = JSON.stringify(location)


  // 如果没有workKey，就获取   sessionStorage  加密相关

  var globErr;

  if (to.path != "/errPage") {
    if (
      to.path == "/jump" ||
      (to.query.shopNo &&
        localStorage.shopNo &&
        to.query.shopNo != localStorage.shopNo)
    ) {
      // 当前页 jump
      localStorage.removeItem("shopNo");
      localStorage.removeItem("basicInfo");
      localStorage.removeItem("isLogin");
      localStorage.removeItem("isScope");
      console.log(
        "jump调过来，本地和 参数 shopNo不一致,删除shopNo 和basicInfo信息"
      );
    }

    if (!localStorage.shopNo) {
      let arg = encodeURIComponent(window.location.href);
      // let jumpUrl = `/#/jump?shopNo=${to.query.shopNo}&redirectUri=${arg}`

      try {
        const result = await jumpApi1(to.query.shopNo);
        localStorage.basicInfo = JSON.stringify(result);
        localStorage.shopNo = result.shopNo;
        // console.log('redirectUri', redirectUri)
      } catch (err) {
        globErr = err;
        console.log("error:" + err);

        // window.location.href = `/#/errPage?info=${err}`
      }
    }

    if (
      to.path != "/externallyproduct" &&
      to.path != "/identifycardapp" &&
      !globErr &&
      to.path != "/productdetailpre" &&
      to.path != "/cardprepage" &&
      to.path != "/jump"
    ) {
      if (typeof localStorage.authentication == "undefined") {
        localStorage.return_url = window.location.href;
        console.log(
          "code值获取",
          Utils.getUrlArg("code"),
          typeof Utils.getUrlArg("code")
        );

        if (to.query.code) {
          await auth(to.query.code);
        } else {
          if (typeof Utils.getUrlArg("code") == "undefined") {
            const APPID = JSON.parse(localStorage.basicInfo).wxAppId;
            console.log(JSON.parse(localStorage.basicInfo).wxAppId);
            const timestamp = new Date();
            const REDIRECT_URI = encodeURIComponent(window.location.href);
            let url = `https://wxjump.yjmbank.cn/get-weixin-code.html?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_base&state=${timestamp}#wechat_redirect`;
            console.warn(
              "跳转过去",
              Utils.getUrlArg("code"),
              typeof Utils.getUrlArg("code")
            );
            window.location.replace(url);
          } else {
            let origin = window.location.origin;
            let hash = window.location.hash;
            let code = Utils.getUrlArg("code");

            if (hash.indexOf("?") >= 0) {
              window.location.href = `${origin}/${hash}&code=${code}`;
            } else {
              window.location.href = `${origin}/${hash}?code=${code}`;
            }
          }
        }
        // if (typeof Utils.getUrlArg('code') == 'undefined') {
        //   const APPID = JSON.parse(localStorage.basicInfo).wxAppId;
        //   console.log(JSON.parse(localStorage.basicInfo).wxAppId)
        //   const timestamp = new Date();
        //   const REDIRECT_URI = encodeURIComponent(window.location.href);
        //   let url = `https://wxjump.yjmbank.cn/get-weixin-code.html?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_base&state=${timestamp}#wechat_redirect`;
        //   console.warn('跳转过去', Utils.getUrlArg('code'), typeof Utils.getUrlArg('code'));
        //   window.location.replace(url);

        // } else {
        //   console.log('执行函数', Utils.getUrlArg('code'))

        //   await auth(Utils.getUrlArg('code'));
        // }

        // if (typeof localStorage.shopNo != 'undefined') {

        // }
      }
    }
  }

  if (globErr) {
    next({
      path: "/errPage",
      query: {
        info: globErr,
      },
    });
  } else {
    next();
  }
});

async function wordKey() {
  try {
    const res = await http.post(
      "/getToken.do",
      {
        client_token: Math.floor(Math.random() * 0xffffffffffffffff)
          .toString(16)
          .padEnd(16, "0"),
      },
      { headers: { isToken: true } }
    );
    // 使用 sessionStorage 每次用户新进入系统就会重新调用一次
    localStorage.workKey = res.result.data;
  } catch (e) {
    console.error(e);
    localStorage.removeItem("workKey");
  }
}
async function jumpApi(shopNo, redirectUri) {
  try {
    const res = await http.post("/support/getTemplateByShopNo", {
      shopNo: shopNo,
    });
    if (res.code == "200") {
      localStorage.basicInfo = JSON.stringify(res.result);
      localStorage.shopNo = res.result.shopNo;
      console.log("redirectUri", redirectUri);
    } else {
      window.location.href = `/#/errPage?info=${res.message}`;
    }
  } catch (e) {
    window.location.href = `/#/errPage?info=${e}`;
    console.error(e);
  }
}

async function jumpApi1(shopNo) {
  return new Promise((resolve, reject) => {
    http
      .post("/support/getTemplateByShopNo", { shopNo: shopNo })
      .then((res) => {
        if (res.code == "200") {
          resolve(res.result);
        } else {
          reject(res.message);
        }
      });
  });

  // const res = await http.post("/support/getTemplateByShopNo", { shopNo: shopNo });
  // if (res.code == '200') {
  //   localStorage.basicInfo = JSON.stringify(res.result);
  //   localStorage.shopNo = res.result.shopNo
  //   console.log('redirectUri', redirectUri)

  // }else {
  //   window.location.href = `/#/errPage?info=${res.message}`
  // }
}

async function auth(code) {
  try {
    const res = await http.post("/passport/loginByAnonymous", { code: code });
    console.log("123", res);
    localStorage.openid = res.result.openId;
    localStorage.authentication = res.result.token;
    localStorage.userInfo = JSON.stringify(res.result);
    // 登陆成功，跳转回登陆前要访问的页面
    window.location.replace(localStorage.return_url);
  } catch (e) {
    console.error(e);
  }
}
export default router;
